const FormatCurrency = ({ amount, currency = 'USD', locale = navigator.language || 'en-US', inMinorUnits = false }) => {
  let value = amount;

  // If amount is a string, try to parse it as float
  if (typeof amount === 'string') {
    value = parseFloat(amount);
  }

  if (typeof value !== 'number' || isNaN(value)) return null;

  const normalized = inMinorUnits ? value / 100 : value;

  try {
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
    }).format(normalized);

    return <span>{formatted}</span>;
  } catch {
    return <span>{normalized}</span>; // fallback if currency is invalid
  }
};

export default FormatCurrency;
